import Loadable from '@townsquare/loadable';

export const RovoButton = Loadable({
	loader: () => import(/* webpackChunkName: "rovo-ai-button" */ './components/RovoButton'),
	loading: () => null,
});
